export const ROOT_PATH = '/';
export const ACCOUNT_PATH = '/account/settings';
export const STATISTICS_PATH = '/statistics';
export const CONFIGURATIONS_PATH = '/configurations';
export const BYOC_PATH = '/byoc';
export const BYOC_COLLECTION_DETAILS_PATH = `${BYOC_PATH}/collection/:id`;
export const BYOC_NEW_COLLECTION_PATH = `${BYOC_PATH}/collections/new`;

// Billing
export const BILLING_PATH = '/account/billing';
export const BILLING_INFO_DETAILS_PATH = `${BILLING_PATH}/user_info/details`;
export const BILLING_PAYMENT_PATH = `${BILLING_PATH}/payment`;

// Billing info
export const USER_BILLING_INFO_PATH = `${BILLING_PATH}/user_info`;

// Purchase orders
export const ORDER_HISTORY = `${BILLING_PATH}/orders/history`;
export const ORDER_DETAILS = `${BILLING_PATH}/order/:orderId`;

// Wire transfer
export const WIRE_TRANSFER_PAYMENT_PATH = `${BILLING_PATH}/payment/wire_transfer`;

// Paypal
export const PAYPAL_EXECUTED_PATH = `${BILLING_PATH}/paypal/executed`;

// Adyen
export const ADYEN_CHECKOUT_CALLBACK_PATH = `${BILLING_PATH}/adyen-checkout/callback`;

export enum SidebarTab {
  DASHBOARD = 'DASHBOARD',
  CONFIGURATOR = 'CONFIGURATOR',
  ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
  STATISTICS = 'STATISTICS',
  BILLING = 'BILLING',
  BYOC = 'BYOC',
}

export const SH_SUPPORT_EMAIL = 'support@sentinel-hub.com';
export const INFO_EMAIL = 'info@sentinel-hub.com';
